import React from "react";

import { Stack } from "@mui/material";

import { AssetClassCategory } from "@fartherfinance/frontend/api/PerformanceGroups/requests/getHoldings";
import { HookResult } from "@fartherfinance/frontend/api/Types";

import useAssetCategoryColors from "@src/multiCustodian/components/Client/Accounts/Holdings/utils/useAssetCategoryColors";
import Skeleton from "@src/sharedComponents/Skeleton/Skeleton";
import Text from "@src/sharedComponents/Typography/Text";

import styles from "./Row.module.css";

const Other = "Other" as AssetClassCategory;

type SecurityData = {
  ticker: string;
  description: string;
  weight: string;
  type?: AssetClassCategory;
};

type SecurityRowProps = HookResult<SecurityData>;

const SecurityRow = (props: SecurityRowProps) => {
  const getColorLabel = useAssetCategoryColors();

  if (props.isLoading) {
    return <SecurityLoadingRow />;
  }

  if (props.hasError) {
    return <SecurityListError />;
  }

  return (
    <div className={styles.container}>
      <div className={styles.row}>
        <div className={styles.colorCol}>
          <div
            className={styles.colorSquare}
            style={{
              background: getColorLabel[props.data.type ?? Other],
            }}
          />
        </div>

        <div className={styles.typeCol}>
          <Text variant={"heading1"} color={"text"} noWrap>
            {props.data.ticker}
          </Text>
        </div>

        <div className={styles.labelCol}>
          <Text variant="body" color={"textSubtle"} noWrap>
            {props.data.description}
          </Text>
        </div>

        <div className={styles.weightCol}>
          <Text variant={"heading1"} color={"text"}>
            {props.data.weight}
          </Text>
        </div>
      </div>
    </div>
  );
};

const SecurityLoadingRow = () => (
  <>
    {Array(10)
      .fill(null)
      .map((_, i) => (
        <div key={i} className={styles.container}>
          <div
            className={styles.row}
            style={{
              flex: 1,
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <Stack direction={"row"} spacing={2}>
              <Skeleton width={10} />
              <Skeleton width={50} />
            </Stack>
            <Stack>
              <Skeleton width={180} />
            </Stack>
            <Stack>
              <Skeleton width={50} />
            </Stack>
          </div>
        </div>
      ))}
  </>
);

const SecurityListError = () => (
  <div style={{ padding: 40, height: 200, alignContent: "center" }}>
    <Text style={{ textAlign: "center" }}>Error loading securities</Text>
  </div>
);

export { SecurityRow };
